import { render, staticRenderFns } from "./ServiceStatusBadge.vue?vue&type=template&id=5fbfe6b0&scoped=true"
import script from "./ServiceStatusBadge.vue?vue&type=script&lang=js"
export * from "./ServiceStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatusBadge.vue?vue&type=style&index=0&id=5fbfe6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfe6b0",
  null
  
)

export default component.exports